
<!-- MODAL POPUP -->
<div class="modal fade" id="lessonstatmodal" data-keyboard="false" data-backdrop="static" tabindex="100" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Lesson stats</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">        
        <div *ngIf="isLessonStatLoading else loadtemplate">          
          loading data...
        </div>  
        <ng-template #loadtemplate>
          <div class="text-center"
            [ngStyle]="{'background-color': lessonStat?.passed ? '#98fb98' : !lessonStat?.passed && hasAnyLessonStarted(lessonStat?.lessons) ? '#FFA756' : '#ec4848ff'}">
            {{lessonStat?.passed ? 'Passed' : !lessonStat?.passed && hasAnyLessonStarted(lessonStat?.lessons) ? 'Not Passed' : 'No Lesson Completed'}}
          </div>
          <p>Score Percentage: {{lessonStat?.scorePercentage}}%</p>
          <p>Attendance Percentage: {{lessonStat?.attendancePercentage}}%</p>
          <app-milestone 
            [activateLessonDeadlineNotification]="lessonStat?.activateLessonDeadlineNotification" 
            [lessons]="lessonStat?.lessons"
            [enrolledDate]="lessonStat?.enrolledDate"
          >
          </app-milestone>
        </ng-template>      
        <div class="d-flex justify-content-center flex-wrap gap-1.5 mt-3">
          <button type="button" class="btn m-0" data-dismiss="modal">Done</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
    *ngIf="moduleStats?.activeStudentsCount > 0"
    class="d-none d-md-flex flex-column flex-md-row justify-content-center align-items-md-end mb-5 py-2"
    style="width: 100vw; height: 35vh;"
    [ngStyle]="{'background-color': moduleStats?.numberOfStudentsWithAtLeastOneCompleteLesson == 0 ? '#dde5e9': '#f7f9fa'}"
>
      <canvas 
        baseChart
        title="Course Stat Summary"
        [datasets]="doughnutChartDatasets" 
        [labels]="doughnutChartLabels" 
        [type]="doughnutChartType"
      ></canvas>
    
    <canvas 
        baseChart 
        title="Lesson Stat Summary"
        [datasets]="doughnutChartDatasets2" 
        [labels]="doughnutChartLabels2" 
        [type]="doughnutChartType"
    ></canvas>
    <p class="my-3">Total Active Students: {{moduleStats?.activeStudentsCount}}</p>
</div>
<app-tablelayout 
    [data]="students" 
    [filterItems]="filterOptions" 
    [count]="count" 
    [columnsToRemove]="removeColumn" 
    [offset]="25" 
    [noRecordText]="noStudentText"
    (loadDataEvent)="loadTableData($event)"
    (rowClicked)="rowClicked($event)"
    >
<app-tablelayout/>

